import React from 'react';
import { UNSAFE_NavigationContext } from 'react-router-dom';

export default function useNavigator() {
  const { navigator } = React.useContext(UNSAFE_NavigationContext);
  return navigator;
}
